import DataGrid2 from '../../..';

export function getUniqueDataField(this: DataGrid2) {
	const primaryColumn = this.columns.find(column => column.isPrimaryKey);

	if (primaryColumn) {
		return primaryColumn.name;
	}

	return 'id'; // fallback
}
